import sArtikel from '../_json/sArtikel';
import sVertrage from '../_json/s_vertrage';
import { LEAD } from '../vars';
import { getSession } from './Session';
import { checkUndefined, checkUndefinedNullOrEmpty, isLocalServer } from './Tools';

export const typTest = 1;
export const typEnd = 2;
export const typAkt = 3;
export const typKL = 4;
export const typKG = 5;
export const endDatum = 2524608000000; // == 01.01.2050
export const endDatumKL = 4102441200000; // == 01.01.2100
export const endDatumKG = 5680278000000; // == 01.01.2150

export function getAktTime() {
    const aktDate = new Date().getTime();
    return aktDate;
}

export function getDatumKG() {
    return endDatumKG;
}

/*
 * Überprüfung ob der Vertrag eine gültige Testphase hat
 */
export function isVertragTestValid(vertrag, vertragArr) {
    if ((vertrag?.dTestphase != 0 && vertrag?.dLeistung == 0 && getTestphaseEndeDatum(vertrag) > getAktTime() && vertrag?.dTestphaseEnd < endDatum) || hasParents(vertrag?.id_parent, vertragArr)) {
        return true;
    }
    return false;
}

/*
 * Überprüfung ob der Vertrag in Testphase ist
 */
export function isVertragTestPhase(vertrag) {
    if (vertrag?.dTestphase != 0 && vertrag?.dLeistung == 0 && getTestphaseEndeDatum(vertrag) > getAktTime()) {
        return true;
    }
    if (vertrag?.dTestphase != 0 && vertrag?.dLeistung == 0 && vertrag?.dTestphaseEnd != 0 && vertrag?.dTestphaseEnd > getAktTime()) {
        return true;
    }
    if (vertrag?.dTestphase != 0 && vertrag?.dLeistung != 0 && getTestphaseEndeDatum(vertrag) > getAktTime()) {
        return true;
    }
    return false;
}

/*
 * Überprüfung ob der Vertrag bezahlt ist
 */
export function isVertragBezahlt(vertrag) {
    if (vertrag?.dLeistung !== 0 && vertrag?.dLeistung < getAktTime() && (vertrag?.dEnd === 0 || getAktTime() < vertrag?.dEnd)) {
        return true;
    }
    if (vertrag?.dLeistung == endDatumKL) {
        return true;
    }
    if (vertrag?.dTestphaseEnd == endDatumKL) {
        return true;
    }
    if (vertrag?.dLeistung != 0) {
        return true;
    }
    return false;
}

export function isVertragBezahltNeu(vertrag, vertragArr) {
    if (hasParents(vertrag?.id_parent, vertragArr)) {
        const parent = getParent(vertrag?.id_parent, vertragArr);
        return isVertragBezahlt(parent);
    } else {
        return isVertragBezahlt(vertrag);
    }
}

export function isVertragTestphaseNeu(vertrag, vertragArr) {
    if (hasParents(vertrag?.id_parent, vertragArr)) {
        const parent = getParent(vertrag?.id_parent, vertragArr);
        return isVertragTestPhase(parent);
    } else {
        return isVertragTestPhase(vertrag);
    }
}

/*
 * Überprüfung ob der Vertrag aktiv ist
 */
export function isVertragAkt(vertrag) {
    if (vertrag?.dLeistung != 0 && vertrag?.dRealEnd < getAktTime()) {
        return true;
    }
    return false;
}

/*
 * Überprüfung ob der Vertrag zu einen Elternvertrag gehört wird genutzt um
 * die Gültigkeit der Testphase zu überprüfen
 */
export function hasParents(idVertrag, vertragArr) {
    for (let i = 0; i < vertragArr.length; i++) {
        if (vertragArr[i].dRealEnd !== 0 && vertragArr[i].dRealEnd < getAktTime()) {
            continue;
        }
        if (idVertrag == vertragArr[i].id) {
            return true;
        }
    }
    return false;
}

/*
 * Liefert den Parentvertrag mit allen children
 */
export function getParents(idVertrag, vertragArr) {
    const parents = [];
    for (let i = 0; i < vertragArr.length; i++) {
        if (vertragArr[i].dRealEnd !== 0 && vertragArr[i].dRealEnd < getAktTime()) {
            continue;
        }
        if (idVertrag == vertragArr[i].id_parent) {
            parents.push(vertragArr[i]);
        }
    }
    return parents;
}

/*
 * Liefert den Parentvertrag mit allen children
 */
export function getParent(idVertrag, vertragArr) {
    for (let i = 0; i < vertragArr.length; i++) {
        if (vertragArr[i].dRealEnd !== 0 && vertragArr[i].dRealEnd < getAktTime()) {
            continue;
        }
        if (idVertrag == vertragArr[i].id) {
            return vertragArr[i];
        }
    }
}

/*
 * Gibt den Namen des Artikels zurück
 */
export function getName(id) {
    for (let i = 0; i < sArtikel.length; i++) {
        if (id == sArtikel[i].i) {
            return sArtikel[i].t;
        }
    }
    return id;
}

/*
 * Gibt den Preis des Artikels zurück
 */
export function getPreis(id) {
    for (let i = 0; i < sArtikel.length; i++) {
        if (id == sArtikel[i].i) {
            return sArtikel[i].p;
        }
    }
    return id;
}

/*
 * Gibt den Zahlungsart des Artikels zurück
 */
export function getZahlungsArt(id) {
    for (let i = 0; i < sArtikel.length; i++) {
        if (id == sArtikel[i].i) {
            return sArtikel[i].z;
        }
    }
    return id;
}

/*
 * Gibt den Mindestlaufzeit des Artikels zurück
 */
export function getLaufZeit(id) {
    for (let i = 0; i < sArtikel.length; i++) {
        if (id === sArtikel[i].i) {
            return sArtikel[i].mlz;
        }
    }
    return 0;
}

/*
 * Gibt die id des Vertrags zurück
 */
export function getIdVertrag(idArtikel) {
    const vertragArr = getSession().firma.v;
    for (let i = 0; i < vertragArr.length; i++) {
        if (idArtikel == vertragArr[i].ia) {
            return vertragArr[i].i;
        }
    }
    return undefined;
}

/*
 * Gibt den Typ des Vertrags zurück
 */
export function getTyp(vertrag) {
    if (vertrag?.dEnd == endDatumKG || vertrag?.dRealEnd == endDatumKG) {
        return typKG;
    }
    if (vertrag?.dTestphase != 0 && vertrag?.dLeistung == 0 && vertrag?.dTestphaseEnd < getAktTime()) {
        return typEnd;
    }
    if (vertrag?.dRealEnd < getAktTime() && vertrag?.dRealEnd > 0) {
        return typEnd;
    }
    if (
        vertrag?.dTestphase != 0 &&
        vertrag?.dLeistung == 0 &&
        vertrag?.dTestphaseEnd > getAktTime() &&
        vertrag?.dTestphaseEnd < endDatum &&
        vertrag?.dRealEnd == 0 &&
        vertrag?.dRealEnd != endDatumKG
    ) {
        return typTest;
    }
    if (vertrag?.dTestphase != 0 && vertrag?.dLeistung == 0 && vertrag?.dTestphaseEnd > getAktTime() && vertrag?.dTestphaseEnd > getAktTime() && vertrag?.dTestphaseEnd > endDatum) {
        return typKL;
    }
    if (vertrag?.dTestphase != 0 && vertrag?.dLeistung == 0 && vertrag?.dTestphaseEnd < getAktTime()) {
        return typEnd;
    }
    if (vertrag?.dRealEnd < getAktTime() && vertrag?.dRealEnd > 0) {
        return typEnd;
    }
    if (vertrag?.dLeistung != 0 && vertrag?.dEnd != endDatumKG) {
        return typAkt;
    }
}

export function getAnzahlTage(vertrag) {
    if (vertrag?.dTestphase != 0 && vertrag?.dLeistung == 0 && vertrag?.dTestphaseEnd != 0) {
        return (vertrag?.dTestphaseEnd - new Date().getTime()) / 86400000 + 1;
    }
    return (getTestphaseEndeDatum(vertrag) - new Date().getTime()) / 86400000 + 1;
}

export function formatTyp(id) {
    if (id == typTest) {
        return 'Test';
    }
    if (id == typEnd) {
        return 'beendet';
    }
    if (id == typAkt) {
        return 'Aktiv';
    }
    if (id == typKL) {
        return 'Kostenlos';
    }
    if (id == typKG) {
        return 'Kostenlos (1.Gebühr)';
    }
}

export function getTestphaseEndeDatum(vertrag) {
    // 30 tage = 2628000000
    if (vertrag?.dTestphase != 0 && vertrag?.dLeistung == 0 && vertrag?.dTestphaseEnd != 0) {
        return vertrag?.dTestphaseEnd;
    } else {
        return vertrag?.dTestphase + 2628000000;
    }
}

export function getTestPhase14Tage(vertrag) {
    return vertrag != undefined ? getTestphaseEndeDatum(vertrag) - 2592000000 : undefined;
}

export function getVertrag(feld: keyof Vertrage, vertrage: Vertrage) {
    if (checkUndefinedNullOrEmpty(vertrage)) return false;

    if (!checkUndefined(vertrage[feld])) return vertrage[feld];
    return false;
}

export function convertVertrage(data: Vertrag[], idFirma: number) {
    const vertrage: Vertrage = {};

    sVertrage?.map((vertrag) => {
        const idVertrag = vertrag?.i;
        const feld = vertrag?.feld;

        if (!LEAD || isLocalServer() || idFirma === 9100 || idFirma === 9300 || idFirma === 9800) {
            vertrage[feld] = true;
        } else {
            for (let i = 0; i < data?.length; i++) {
                const artikel = data?.[i]?.id_artikel;
                if (((Array.isArray(idVertrag) && idVertrag.includes(artikel)) || artikel === idVertrag) && (checkUndefined(vertrage[feld]) || vertrage[feld] === false)) {
                    const v = data[i];
                    // Vertrag ist abgelaufen
                    if (v.dRealEnd > 0 && v.dRealEnd < new Date().getTime()) vertrage[feld] = false;
                    // Vertrag ist aktiv und bezahlt
                    else if (isVertragBezahlt(v)) vertrage[feld] = true;
                    // Vertrag ist in Testphase
                    else if (isVertragTestPhase(v)) vertrage[feld] = v;
                    // Parent prüfen
                    else if (!hasParents(v.id_parent, data))
                        vertrage[feld] = false; // kein Parent
                    else {
                        const parent = getParent(v.id_parent, data);
                        if (isVertragBezahlt(parent)) vertrage[feld] = true;
                    }
                }
            }
        }
    });

    return vertrage;
}

export type Vertrag = {
    anzahl?: number;
    bemerkung?: string;
    dEnd?: number;
    dLeistung?: number;
    dRealEnd?: number;
    dTestphase?: number;
    dTestphaseEnd?: number;
    dVertrag?: number;
    einrichtungGS?: number;
    einrichtungRechnung?: number;
    id?: number;
    id_artikel?: number;
    id_firma?: number;
    id_parent?: number;
    lastschrift?: number;
    rabatt?: number;
};

export type Vertrage = {
    uwe?: boolean | Vertrag;
    hp_alt?: boolean | Vertrag;
    hp_gruppe?: boolean | Vertrag;
    json?: boolean | Vertrag;
    hp_kp2?: boolean | Vertrag;
    tracking?: boolean | Vertrag;
    akte?: boolean | Vertrag;
    carscanner?: boolean | Vertrag;
    inz?: boolean | Vertrag;
    lead?: boolean | Vertrag;
    individ?: boolean | Vertrag;
};

export type Testphasen = {
    uwe?: boolean;
    hp_alt?: boolean;
    hp_gruppe?: boolean;
    json?: boolean;
    hp_kp2?: boolean;
    tracking?: boolean;
    akte?: boolean;
    carscanner?: boolean;
    inz?: boolean;
    lead?: boolean;
    individ?: boolean;
};
